import Axios from 'axios'
import router from '../../router'
import {authUrls} from '../defaults/.url'

export default {
  async do_login(context, loginData) {
  const postData = {
    email: loginData.email,
    password: loginData.password
  }

  try {
    const response = await Axios.post(authUrls.login, postData)
    
    localStorage.setItem('access_token', response.data.auth_token)
    localStorage.setItem('session_token', response.data.auth_token)
    localStorage.setItem('unem', JSON.stringify(response.data))
    
    // ✅ ADD THIS ONE LINE - Save tracker_id separately
    if (response.data.tracker_id) {
      localStorage.setItem('tracker_id', response.data.tracker_id)
    }
    
    if (response.data.public_id) {
      localStorage.setItem('lkjhgfdsa', response.data.public_id)
      localStorage.setItem('user_public_id', response.data.public_id)
    }
    
    await context.dispatch('get_credentials')
    
    try {
      const user = await context.dispatch('get_user_by_email', loginData.email)
      if (user) {
        if (user.public_id) {
          localStorage.setItem('user_public_id', user.public_id)
          localStorage.setItem('lkjhgfdsa', user.public_id) 
        }
        
        localStorage.setItem('user_first_name', user.first_name || '')
        localStorage.setItem('user_last_name', user.last_name || '')
        localStorage.setItem('user_name', `${user.first_name || ''} ${user.last_name || ''}`.trim())
        localStorage.setItem('user_email', user.email || '')
        localStorage.setItem('user_data', JSON.stringify(user))
        
        if (user.phone_number) {
          let phoneNumber = user.phone_number.replace(/-/g, '')
          localStorage.setItem('user_phone', phoneNumber)
          localStorage.setItem('user_phone_number', phoneNumber)
        }
      }
    } catch (error) {
    }
    
    try {
      const bookingDetails = await context.dispatch('get_booking_details_by_email', loginData.email)
      if (bookingDetails) {
        if (bookingDetails.country) {
          localStorage.setItem('user_country', bookingDetails.country)
          localStorage.setItem('user_city', bookingDetails.city || '')
          localStorage.setItem('user_country_code', bookingDetails.country_code || '')
        }
        
        if (bookingDetails.phone_number && !localStorage.getItem('user_phone')) {
          let phoneNumber = bookingDetails.phone_number.replace(/-/g, '')
          localStorage.setItem('user_phone', phoneNumber)
          localStorage.setItem('user_phone_number', phoneNumber)
        }
      }
    } catch (error) {
    }
    
    const sessionId = localStorage.getItem('lkjhgfdsa')
    
    if (!sessionId) {
      try {
        const unem = JSON.parse(localStorage.getItem('unem') || '{}')
        if (unem.public_id) {
          localStorage.setItem('lkjhgfdsa', unem.public_id)
          localStorage.setItem('user_public_id', unem.public_id)
        }
      } catch (e) {
      }
    }
    
    await new Promise(resolve => setTimeout(resolve, 200))
    await context.dispatch('find_view')
    
  } catch (error) {
    if (error.response) {
      const errorMessage = error.response.data ? error.response.data.message : null
      alert(errorMessage || 'Login failed. Please check your credentials.')
    } else {
      alert('Network error. Please check your connection.')
    }
  }
},
  
  request_password_reset(context, data) {
    Axios.post(authUrls.request_reset, data)
      .then(function(response) {
        localStorage.setItem('access_token', response.data.auth_token)
        router.push({
          name: 'Login'
        })
      })
      .catch(function(error) {
        const errorMessage = error.response && error.response.data ? error.response.data.message : null
        alert(errorMessage || 'Password reset request failed')
      })
  },
  
  reset_password(context, data) {
    Axios.post(authUrls.reset_password + data.reset_id, data)
      .then(function(response) {
        localStorage.setItem('access_token', response.data.auth_token)
        window.location.replace('/login')
      })
      .catch(function(error) {
        const errorData = error.response ? error.response.data : { message: 'Reset failed' }
        context.commit('UPDATE_ERRORS', errorData)
      })
  },
  
  async get_credentials(context) {
    try {
      const response = await Axios.get(authUrls.user_details)
      
      if (response.status !== 200) {
        throw new Error('Invalid credentials')
      }
      
      context.commit('GET_STATE', response.data)
      
      return response.data
      
    } catch (error) {
      alert('Wrong Credentials')
      throw error 
    }
  },
  
  find_view(context) {
    let usertype_local = {}
    try {
      usertype_local = JSON.parse(localStorage.getItem('unem') || '{}')
    } catch (e) {
      try {
        const userData = JSON.parse(localStorage.getItem('user_data') || '{}')
        if (userData.user_type_id) {
          usertype_local.user_type_id = userData.user_type_id
        }
      } catch (e2) {
      }
    }
    
    const usertype_id = usertype_local.user_type_id
    
    if (usertype_id === '230862f9') {
      window.location.replace('/bookings/inspection')
    } else {
      window.location.replace('/dashboard')
    }
  },

reset_storage(context, trackerId) {
  const token = localStorage.getItem('access_token')
  const id = trackerId || localStorage.getItem('tracker_id')
  
  if (!token || !id) {
    localStorage.clear()
    router.push({ name: 'Login' })
    return
  }
  
  Axios({
    method: 'GET',
    url: authUrls._doLogout + id,
    headers: {
      'Authorization': 'Bearer ' + token
    }
  })
  .catch(function(error) {})
  .finally(function() {
    localStorage.clear()
    router.push({ name: 'Login' })
  })
}
}